import React from "react";
import "./FooterRoutes.css"; // Make sure this file is in the same directory

const TermsAndConditions = () => {
  return (
    <div className="container">
      <h1 className="title">Terms and Conditions</h1>
      <p>
        Welcome to spectsgenie, these terms and conditions outline the rules and
        regulations for the use of our website.
      </p>

      <p>
        By accessing this website, we assume you accept these terms and
        conditions. Do not continue to use our website if you do not agree to
        take all of the terms and conditions stated on this page.
      </p>

      <p>
        The following terminology applies to these Terms and Conditions, Privacy
        Statement, and Disclaimer Notice and all Agreements: "Client", "You",
        and "Your" refer to you, the person logged on this website and compliant
        to the Company's terms and conditions. "The Company", "Ourselves", "We",
        "Our", and "Us", refers to our Company. "Party", "Parties", or "Us",
        refers to both the Client and ourselves. All terms refer to the offer,
        acceptance, and consideration of payment necessary to undertake the
        process of our assistance to the Client in the most appropriate manner
        for the express purpose of meeting the Client's needs in respect of
        provision of the Company's stated services, in accordance with and
        subject to, prevailing law of Karnataka, India. Any use of the above
        terminology or other words in the singular, plural, capitalization,
        and/or he/she or they, are taken as interchangeable and therefore as
        referring to same.
      </p>
      <br></br>
      <div className="section">
        <h2 className="subtitle">Cookies</h2>
        <p>
          We employ the use of cookies. By accessing spectsgenie.com, you agreed
          to use cookies in agreement with our website’s Privacy Policy.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">License</h2>
        <p>
          Unless otherwise stated, spectsgenie and/or its licensors own the
          intellectual property rights for all material on our website. All
          intellectual property rights are reserved. You may access this from
          spectsgenie for your own personal use subjected to restrictions set in
          these terms and conditions.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">Restrictions</h2>
        <p>You are specifically restricted from all of the following:</p>
        <ul>
          <li>- publishing any of our website material in any other media;</li>
          <li>
            - selling, sublicensing, and/or otherwise commercializing any of our
            website material;
          </li>
          <li>
            - publicly performing and/or showing any of our website material;
          </li>
          <li>
            - using this website in any way that is or may be damaging to this
            Website;
          </li>
          <li>
            - using this website in any way that impacts user access to this
            Website;
          </li>
          <li>
            - using this website contrary to applicable laws and regulations, or
            in any way may cause harm to the Website, or to any person or
            business entity;
          </li>
          <li>
            - engaging in any data mining, data harvesting, data extracting, or
            any other similar activity in relation to this Website;
          </li>
          <li>
            - using this website to engage in any advertising or marketing.
          </li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">Your Privacy</h2>
        <p>
          Please read our <a href="#">Privacy Policy</a>.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">Reservation of Rights</h2>
        <p>
          We reserve the right to request that you remove all links or any
          particular link to our website. You approve to immediately remove all
          links to our Website upon request. We also reserve the right to amend
          these terms and conditions and its linking policy at any time. By
          continuously linking to our website, you agree to be bound to and
          follow these linking terms and conditions.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">Removal of Links from Our Website</h2>
        <p>
          If you find any link on our website that is offensive for any reason,
          you are free to contact and inform us at any moment. We will consider
          requests to remove links but we are not obligated to do so or to
          respond to you directly.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">Frames</h2>
        <p>
          Without prior approval and written permission, you may not create
          frames around our Webpages that alter in any way the visual
          presentation or appearance of our Website.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">Content Liability</h2>
        <p>
          We shall not be held responsible for any content that appears on your
          Website. You agree to protect and defend us against all claims that
          are rising on your Website. No link(s) should appear on any Website
          that may be interpreted as libelous, obscene, or criminal, or which
          infringes, otherwise violates, or advocates the infringement or other
          violation of, any third-party rights.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">Your Consent</h2>
        <p>
          By using our website, you hereby consent to our terms and conditions
          and agree to its terms.
        </p>
      </div>

      <div className="section">
        <h2 className="subtitle">Update</h2>
        <p>
          Should we update, amend, or make any changes to this document, those
          changes will be prominently posted here.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
